import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

export type TCashSession = {
  cash_register_id: number;
  cashier_id: number;
  cashier_document: string,
  closed_at: string | null;
  created_at: string;
  difference: number | null;
  final_amount: number | null;
  id: number;
  initial_amount: number | null;
  opened_at: string;
  opened_by_id: number;
  opened_by_document: string,
  status: 'OPEN' | 'CLOSED' | 'LOCKED';
  total_sales_cash: number | null;
  total_sales_non_cash: number | null;
  uid: string;
  updated_at: string;
  cashier_name: string,
  opened_by_name: string,
  pos_uid: string,
}
type TSessionContext = {
  list: TCashSession[],
  current: TCashSession,
  currentSelected: TCashSession|undefined,
  showModal: boolean
}
const initialState:TSessionContext =  {
  list: [],
  current: {
    cash_register_id: 0,
    cashier_id: 0,
    closed_at: null,
    created_at: '',
    difference: null,
    final_amount: null,
    id: 0,
    initial_amount: null,
    opened_at: '',
    opened_by_id: 0,
    status: 'OPEN',
    total_sales_cash: null,
    total_sales_non_cash: null,
    uid: "",
    updated_at: '',
    cashier_name: '',
    opened_by_name: '',
    pos_uid: '',
    cashier_document: '',
    opened_by_document: ''
  },
  showModal: false,
  currentSelected: undefined
}
interface SessionContextType {
  session: TSessionContext;
  updateSession: (newConfig: Partial<TSessionContext>) => void;
}
interface SessionProviderProps {
  children: ReactNode;
}

const SessionContext = createContext<SessionContextType>({session:initialState,updateSession:()=>{}});

export const SessionProvider:React.FC<SessionProviderProps> = ({ children }) => {
  const [session, setSession] = useState(initialState);
  const updateSession = useCallback((newConfig:Partial<TSessionContext>) => {
    setSession((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);
  
  const contextValue = useMemo(() => ({
    session,
    updateSession,
  }), [session, updateSession]);

  return (
    <SessionContext.Provider value={contextValue}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  return useContext(SessionContext);
};